import FilterMenu from './FilterMenu';

export default FilterMenu;
